import React, { Component, PropTypes } from 'react';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import { connect } from 'react-redux';
import { onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import FontConfigurator from '../../../widgets/FontConfigurator/FontConfigurator';
import CSSLength from '../../../../../lib/css-property-parser/CSSLength';

const prefix = 'header.userBar';

class HeaderStyles extends Component {
    render() {
        const fontSize = new CSSLength(this.props.userBar.fontSize, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        return (
            <div className="HeaderStyles">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12">
                        <FontConfigurator
                            fontWeightClass="col-xs-12 col-sm-4"
                            fontFamilyClass="col-xs-12 col-sm-8"
                            fontFamilyProperty={'header.userBar.font'}
                            fontWeightProperty={'header.userBar.fontWeight'}
                        >
                            <div className="col-xs-12 col-sm-2 spark-pad-b-1">
                                Normal
                                <PresetColorPicker
                                    color={this.props.userBar.color.normal}
                                    isDisabled={this.props.isDisabled}
                                    onColorChange={this.props.onThemePropChange('color.normal')}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-2 spark-pad-b-1">
                                Hover
                                <PresetColorPicker
                                    color={this.props.userBar.color.hover}
                                    isDisabled={this.props.isDisabled}
                                    onColorChange={this.props.onThemePropChange('color.hover')}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Font Size"
                                    onChange={this.props.onThemePropChange('fontSize')}
                                    isDisabled={this.props.isDisabled}
                                    defaultValue={fontSize.px}
                                    values={this.props.availableFontSizes.map(v => ({
                                        key: v.toString(),
                                        label: v.toString()
                                    }))}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Text Transform"
                                    onChange={this.props.onThemePropChange('textTransform')}
                                    isDisabled={this.props.isDisabled}
                                    defaultValue={this.props.userBar.textTransform}
                                    values={['uppercase', 'lowercase', 'capitalize', 'none'].map(v => ({
                                        key: v.toString(),
                                        label: v.toString()
                                    }))}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Text Decoration (Normal)"
                                    onChange={this.props.onThemePropChange('textDecoration.normal')}
                                    isDisabled={this.props.isDisabled}
                                    defaultValue={this.props.userBar.textDecoration.normal}
                                    values={this.props.availableTextDecoration.map(v => ({
                                        key: v.toString(),
                                        label: v.toString()
                                    }))}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-4" />
                            <div className="col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Text Decoration (Hover)"
                                    onChange={this.props.onThemePropChange('textDecoration.hover')}
                                    isDisabled={this.props.isDisabled}
                                    defaultValue={this.props.userBar.textDecoration.hover}
                                    values={this.props.availableTextDecoration.map(v => ({
                                        key: v.toString(),
                                        label: v.toString()
                                    }))}
                                />
                            </div>
                        </FontConfigurator>
                    </div>
                </div>
            </div>
        );
    }
}

HeaderStyles.propTypes = {
    availableFonts: PropTypes.array,
    availableFontSizes: PropTypes.array,
    availableFontWeights: PropTypes.object,
    tagNameName: PropTypes.string,
    onThemePropChange: PropTypes.func
};

const mapHeaderStylesStateToProps = (state, ownProps) => ({ ...state.app.data.theme.header, ...state.theme.header });

const mapHeaderStylesDispatchToProps = dispatch => ({
    onThemePropChange: onThemePropChange(dispatch, prefix)
});

export default connect(mapHeaderStylesStateToProps, mapHeaderStylesDispatchToProps)(HeaderStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/header/Styles.js